import Api from '@/utils/api'
import BasicConfig from '@/config/basic'

/** RBAC：按类型返回菜单/模块/按钮权限码（Java 网关，需 javaToken） */
export function getPermissionCodesByType (query = {}) {
  return Api.get(`${BasicConfig.jDomain}/system/rbac/codes-by-type`, {
    params: { ...query, axiosType: 'java' }
  })
}
export function getImages (query) {
  return Api.get('/api/get_store', { params: { ...query, axiosType: 'python' } })
}

export function loginJava(body = {}) {
  return Api.post(
    `${BasicConfig.jDomain}/auth/login/token`,
    { ...body },
    {
      __skipAuthRefresh: true, // token 刷新接口自身不参与 401 自动刷新/重试，避免死循环
      __skipTokenCheck: true   // 本接口用 body 中的 user token 换取 java token，此时 Redux 尚无 javaToken
    }
  )
}

export function loginYs7Java(query = {}) {
  return Api.get(`${BasicConfig.jDomain}/yingshi/token`, {
    params: {
      ...query,
    }, 
    __skipAuthRefresh: true,
    __skipTokenCheck: true
  })
}